module.exports = __webpack_public_path__ + "img/brave.ff08f035.png";